/**
 * 一个通用的响应数据解压器
 * PS：目前接入本解压器的请求主要如下：
 * 1. doc 的 opendoc 请求的响应数据
 * 2. sheet 的 chunk 数据请求的响应数据
 */
var DocumentDataUnpacker = /** @class */ (function () {
    function DocumentDataUnpacker() {
    }
    /**
     * opendoc 回包的响应数据解压器
     *
     * 大致的数据格式如下：
     * key : 数据项的名称
     * type : 数据项的类型，目前为 json 或 text
     * dataLength : 改数据项的对应数据的长度
     * data : 具体的数据内容
     *
     * 举🌰：
     * head
     * json
     * 8
     * 12345678
     * 上述描述的一个数据项就是 key 为 head, 类型为 json， 数据长度为8，数据内容为 '12345678'
     *
     * @param data 待解压的数据
     * @returns 解压后的数据对象
     */
    Object.defineProperty(DocumentDataUnpacker, "unpackData", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (data) {
            var parseResult = {};
            var reg = /(.+)\n(.+)\n(.+)\n/g;
            do {
                // 一次正则匹配识别三行的内容
                var result = reg.exec(data);
                if (!result) {
                    break;
                }
                // 分别解析出数据的 key, type, 和 length，并提取对应的 value 数据内容
                var matchResult = result[0], key = result[1], type = result[2], lengthStr = result[3];
                var length_1 = parseInt(lengthStr, 10);
                var value = data.substr(result.index + matchResult.length, length_1);
                // 根据数据的 type 对 value 进行类型转换
                parseResult[key] = this.parseValueByType(type, value);
                reg.lastIndex += length_1;
            } while (reg.lastIndex > 0);
            return parseResult;
        }
    });
    Object.defineProperty(DocumentDataUnpacker, "parseValueByType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (type, value) {
            if (type === 'json' || type === 'jsonText') {
                return JSON.parse(value);
            }
            return value;
        }
    });
    return DocumentDataUnpacker;
}());
export { DocumentDataUnpacker };
